import { FC } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { useRpPayoutsForm } from './useRpPayoutsForm'
import { EQueryKeysConstant } from '../../constants/EQueryKeysConstant'
import { WrapDrawerEditForm } from '../index'
import { TRpPayoutsFormData } from './schema'
import RpPayoutsFormBase from './base'
import { Prp2boxApiPayouts } from '../../prp2boxApi'
import { CreateRpPayoutPayload } from '../../prp2boxApi/payouts'

type TRpPayoutsFormEditProps = {
  id: string
}

const RpPayoutsFormEdit: FC<TRpPayoutsFormEditProps> = ({ id }) => {
  const queryClient = useQueryClient()
  const hookForm = useRpPayoutsForm()

  const { data: entity } = useQuery([`get rpPayouts`, id], () => Prp2boxApiPayouts.getById(Number(id)), {
    onSuccess: (data) => {
      hookForm.reset(data)
    },
    refetchOnWindowFocus: false,
  })

  const updateMutation = useMutation(
    (payload: CreateRpPayoutPayload) => Prp2boxApiPayouts.update(Number(id), payload),
    {
      onSuccess: () => {
        toast.success('Список выплат успешно обновлен')
        queryClient.invalidateQueries([EQueryKeysConstant.RP_PAYOUTS])
      },
    }
  )

  const handleSave = (data: TRpPayoutsFormData) => {
    // При необходимости преобразуйте данные
    updateMutation.mutate(data)
  }

  return (
    <WrapDrawerEditForm
      title={`Редактирование списка выплат ${entity?.name || ''}`}
      onSave={hookForm.handleSubmit(handleSave)}
      isShowSaveBtn
      isShowEditBtn={false}
      isShowDeleteBtn={false}
      isShowBlockBtn={false}
      busyText=""
      isBusy={false}>
      <RpPayoutsFormBase hookForm={hookForm} />
    </WrapDrawerEditForm>
  )
}

export default RpPayoutsFormEdit
